import { push } from 'connected-react-router';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { hideAddFormModal } from './addFormModal';

export const ADD_FORM_REQUEST = 'ADD_FORM_REQUEST';
export const ADD_FORM_SUCCESS = 'ADD_FORM_SUCCESS';
export const ADD_FORM_FAILURE = 'ADD_FORM_FAILURE';
export const RESET_ADDING_FORM = 'RESET_ADDING_FORM';

function requestAddForm() {
  return {
    type: ADD_FORM_REQUEST,
    isAddingForm: true
  };
}

function receiveAddForm(addingFormResults) {
  return {
    type: ADD_FORM_SUCCESS,
    isAddingForm: false,
    addingFormResults
  };
}

function rejectAddForm(addingFormResults) {
  return {
    type: ADD_FORM_FAILURE,
    isAddingForm: false,
    addingFormResults
  };
}

function resetAddForm() {
  return {
    type: RESET_ADDING_FORM,
    addingFormResults: null
  };
}

export function addForm(parentForm, data, onlineForm) {
  const postData = {
    parentFormId: parentForm ? parentForm.itemId || parentForm.id : null,
    isOnline: onlineForm,
    client: data.clientId,
    legalEntity: data.legalEntity ? data.legalEntity.id : null,
    wFormReference: data.wFormReference,
    crsFormReference: data.crsFormReference,
    whdAgents: data.whdAgents,
    customerType: data.customerType,
    usNonUs: data.usNonUs,
    wForm: (((parentForm && data.addImyLayer) || (data.whdAgents && (data.whdAgents.uswa || data.whdAgents.qi || data.whdAgents.ffi)))
      && data.customer && (data.wForms && data.wForms.length > 0)) ? {
        customer: data.customer ? data.customer.id : null,
        type: data.formType,
        forms: data.wForms,
        date: data.wFormDate
      } : null,
    crsForm: data.whdAgents && data.whdAgents.ffi && data.crsCustomer && (data.crsForms && data.crsForms.length > 0) ? {
      customer: data.crsCustomer ? data.crsCustomer.id : null,
      type: data.crsFormType,
      forms: data.crsForms,
      date: data.crsFormDate
    } : null,
    imy: parentForm || (!parentForm && data.whdAgents && (data.whdAgents.uswa || data.whdAgents.qi || data.whdAgents.ffi)
      && !onlineForm && data.formType && data.formType.indexOf('imy') !== -1) ? {
        statementType: data.whdStatementType,
        effectiveDate: data.whdEffectiveDate,
        statement: data.whdStatement,
        accountNumber: data.imyAccountNumber ? data.imyAccountNumber.id : null,
        newAccountNumber: !data.imyAccountNumber ? data.newImyAccountNumber : null,
        beneficiaryForms: data.benefForms
      } : null,
    supportingDocs: {
      documents: data.supportingDocs,
      originEmail: data.originEmail
    }
  };

  return (dispatch) => {
    dispatch(requestAddForm());

    const promise = () => ApiService
      .addForm(postData)
      .then((response) => {
        if (response.data.redirectUrl) {
          dispatch(hideAddFormModal());
          return dispatch(push(response.data.redirectUrl));
        }
        return dispatch(receiveAddForm(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectAddForm));
        }
      });
    return promise();
  };
}

export function hideAddFormResults() {
  return dispatch => dispatch(resetAddForm());
}
